"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function registerHttpPlugin(shaka, httpPlugin) {
    var networkingEngine = shaka.net.NetworkingEngine;
    var httpPluginEntry = httpPlugin.entry.bind(httpPlugin);
    networkingEngine.registerScheme('http', httpPluginEntry);
    networkingEngine.registerScheme('https', httpPluginEntry);
}
exports.default = registerHttpPlugin;
//# sourceMappingURL=registerHttpPlugin.js.map